import { render, staticRenderFns } from "./editNewsList.vue?vue&type=template&id=aba0677a&scoped=true&"
import script from "./editNewsList.vue?vue&type=script&lang=js&"
export * from "./editNewsList.vue?vue&type=script&lang=js&"
import style0 from "./editNewsList.vue?vue&type=style&index=0&id=aba0677a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba0677a",
  null
  
)

export default component.exports